import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const setScrollTrigger = (): void => {
  ScrollTrigger.config({
    autoRefreshEvents: 'DOMContentLoaded',
    ignoreMobileResize: true,
  });
  ScrollTrigger.refresh();
};